import ThemesTypes from "./themes.types";

export const toggleColorTheme = () => ({
  type: ThemesTypes.TOGGLE_COLOR_THEME,
});
